import React from 'react';
import '../../styles/components/ModalHttpTransfersRunning.scss';
import { language } from '../../services/LanguageService';
import { getRunningHttpGatewayTransfers } from '../../helpers/transfer';
import { AsperaTransferActivityItem } from '../AsperaTransferActivityItem';
import { AsperaTransfer } from '../../classes/AsperaTransfer';
/**
 * React Component
 *
 * The ModalHttpTransfersRunning renders the running transfer in a caught modal
 *
 * @example
 * ```javascript
 * <ModalHttpTransfersRunning />
 * ```
 */
export class ModalHttpTransfersRunning extends React.Component {
    constructor() {
        super(...arguments);
        this.transfers = [];
        this.checkTransfers = (timeout = 0) => {
            const { redirectUrl } = this.props;
            this.timeout = setTimeout(() => {
                this.transfers = getRunningHttpGatewayTransfers();
                if (this.transfers.length) {
                    this.setState({});
                    this.checkTransfers(2000);
                }
                else {
                    redirectUrl ? window.location.replace(redirectUrl) : window.location.reload();
                }
            }, timeout);
        };
    }
    componentWillUnmount() {
        const { modalClose } = this.props;
        if (this.timeout)
            clearTimeout(this.timeout);
        modalClose();
    }
    componentDidMount() {
        this.checkTransfers();
    }
    render() {
        return (React.createElement("div", { className: "modal-body-http-gateway-running-warning" },
            React.createElement("p", null, language.get('httpWarningModal.subtext')),
            React.createElement("div", { className: "transfer-list" }, this.transfers.map((transfer, index) => {
                return React.createElement(AsperaTransferActivityItem, { openTransferInfo: () => { }, key: index, transfer: new AsperaTransfer(transfer) });
            }))));
    }
}
